import { ticketBaiService } from "@/_services";

export const ticketBai = {
  namespaced: true,
  state: {
    entity: {
      data: [],
      status: {},
    },
    register: {
      data: [],
      status: {},
    },
    invoices: {
      data: {},
      status: {},
    },
    xml: {
      data: {},
      status: {},
    },
  },
  mutations: {
    getConfigRequest(state) {
      state.entity.status = {
        loading: true,
      };
    },
    getConfigError(state, error) {
      state.entity.data = [];
      state.entity.status = {
        loading: false,
        error,
      };
    },
    getConfigSuccess(state, res) {
      state.entity.data = res;
      state.entity.status = {
        loaded: true,
      };
    },
    registerRequest(state) {
      state.register.status = {
        loading: true,
      };
    },
    registerError(state, error) {
      state.register.data = [];
      state.register.status = {
        loading: false,
        error,
      };
    },
    registerSuccess(state, res) {
      state.register.data = res;
      state.register.status = {
        loaded: true,
      };
    },
    invoicesRequest(state) {
      state.invoices.status = {
        loading: true,
      };
    },
    invoicesError(state, error) {
      state.invoices.data = [];
      state.invoices.status = {
        loading: false,
        error,
      };
    },
    invoicesSuccess(state, res) {
      state.invoices.data = res;
      state.invoices.status = {
        loaded: true,
      };
    },
    xmlRequest(state) {
      state.xml.status = {
        loading: true,
      };
    },
    xmlError(state, error) {
      state.xml.data = [];
      state.xml.status = {
        loading: false,
        error,
      };
    },
    xmlSuccess(state, res) {
      state.xml.data = res;
      state.xml.status = {
        loaded: true,
      };
    },
  },
  actions: {
    getConfig({ commit }) {
      commit("getConfigRequest");
      ticketBaiService
        .getConfig()
        .then((res) => {
          commit("getConfigSuccess", res);
        })
        .catch((error) => {
          commit("getConfigError", error);
        });
    },
    registerConfig({ commit }, body) {
      commit("registerRequest");
      ticketBaiService
        .registerConfig(body)
        .then((res) => {
          commit("registerSuccess", res);
        })
        .catch((error) => {
          commit("registerError", error);
        });
    },
    getInvoices({ commit }, filters) {
      commit("invoicesRequest");
      ticketBaiService
        .getInvoices(filters)
        .then((res) => {
          commit("invoicesSuccess", res);
        })
        .catch((error) => {
          commit("invoicesError", error);
        });
    },
    downloadXml({ commit }, req) {
      commit("xmlRequest");
      ticketBaiService
        .downloadXml(req.clientId, req.invoiceId)
        .then((res) => {
          commit("xmlSuccess", res);
        })
        .catch((error) => {
          commit("xmlError", error);
        });
    },
  },
};
